module.exports = __webpack_public_path__ + "img/assistance.b0ae0904.png";